/** @jsxImportSource @emotion/react */
"use client";

import { useTranslations } from "@i18n/react";
import { forwardRef } from "react";

import type { ThemeType } from "../../../../../global/emotion";
import { spacing } from "../../../../../global/emotion";
import { Text } from "../../../_base/_core/Text/Text.emotion";
import { useFormField } from "./FormField.emotion";

export const FormMessage = forwardRef<
  HTMLParagraphElement,
  React.HTMLAttributes<HTMLParagraphElement>
>(({ children, ...props }, ref) => {
  const t = useTranslations();
  const { error, formMessageId } = useFormField();

  let body: React.ReactNode = children;

  if (error?.message) {
    const errorMessage = String(error.message);
    try {
      const translated = t(errorMessage);
      body = translated !== errorMessage ? translated : errorMessage;
    } catch {
      // If translation fails, use the original message
      body = errorMessage;
    }
  }

  if (!body) {
    return null;
  }

  return (
    <Text
      ref={ref}
      type="detail"
      size="l"
      id={formMessageId}
      css={(theme: ThemeType) => ({
        color: theme.semanticColors.errorError,
        marginHorizontal: spacing.xs,
      })}
      {...props}
    >
      {body}
    </Text>
  );
});

FormMessage.displayName = "FormMessage";
